import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import { Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeAdvogadoSustentacaoOralEletronica extends Component {
    get titlePadrao() {
        if (this.props.dataSessaoOrigem) {
            return (
                <Typography>
                    Sustentação oral eletrônica proveniente da sessão de {this.props.dataSessaoOrigem} (art. 134-A, § 6º-A, RITST)
                </Typography>
            );
        }
        return <Typography>Pedido de sustentação oral eletrônica</Typography>;
    }
    corPadrao = 'black';
    opacidadePadrao = '1';

    title = null;
    color = null;
    removerTooltip = false;
    idPadrao = 'idIconeAdvogadoSustentacaoOralEletronica';

    static get sxPadrao() {
        return {
            color: this.corPadrao,
            fill: this.corPadrao,
            fillOpacity: this.opacidadePadrao
        };
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            title: observable,
            color: observable,
            removerTooltip: observable,
            idPadrao: observable,
            atualizarPropsIcone: action,
            adicionarSxPadrao: action
        });

        runInAction(() => {
            this.idPadrao = this.props.id ? this.props.id : this.idPadrao;
        });
    }

    atualizarPropsIcone(propsIcone) {
        this.propsIcone = propsIcone;
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            runInAction(() => {
                this.propsIcone.sx = IconeAdvogadoSustentacaoOralEletronica.sxPadrao;
            });
        } else {
            runInAction(() => {
                this.propsIcone.sx = { ...IconeAdvogadoSustentacaoOralEletronica.sxPadrao, ...this.propsIcone.sx };
            });
        }
    }

    render() {
        if (this.removerTooltip) {
            return <SmartDisplayIcon sx={this.props.sx ? this.props.sx : this.props.style} />;
        } else {
            return (
                <Tooltip title={this.titlePadrao}>
                    <SmartDisplayIcon
                        id={this.idPadrao}
                        sx={this.props.sx ? this.props.sx : this.props.style}
                    />
                </Tooltip>
            );
        }
    }
}

IconeAdvogadoSustentacaoOralEletronica.corPadrao = 'black';

IconeAdvogadoSustentacaoOralEletronica.opacidadePadrao = '1';

IconeAdvogadoSustentacaoOralEletronica.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node,
    sx: PropTypes.object,
    style: PropTypes.object,
    id: PropTypes.string,
    dataSessaoOrigem: PropTypes.string
};

export default observer(IconeAdvogadoSustentacaoOralEletronica);
